type IndexedBodyParagraph = {
  index: number;
};

export const useResolveBodyParagraphIndexes = (
  paragraphPositions: number[],
  bodyParagraphs: IndexedBodyParagraph[]
) => {
  return paragraphPositions.flatMap((position) => {
    const paragraph = bodyParagraphs[position - 1];

    return paragraph == undefined ? [] : [paragraph.index];
  });
};
